module.exports = __webpack_public_path__ + "img/fossilImg1.e83c1ce7.jpg";